export interface PasswordRule {
  key: string
  label: string
  isMet: (password: string) => boolean
}

// Mirrors MiCredentials' own account rule (and the backend's MiCredentialsPasswordPolicy),
// which its API does not enforce.
export const PASSWORD_RULES: PasswordRule[] = [
  { key: 'length', label: 'At least 8 characters', isMet: (p) => p.length >= 8 },
  { key: 'case', label: 'Uppercase and lowercase letters', isMet: (p) => /[A-Z]/.test(p) && /[a-z]/.test(p) },
  { key: 'number', label: 'At least one number', isMet: (p) => /\d/.test(p) },
  { key: 'special', label: 'A special character (e.g. ! @ # $ ?) or at least 12 characters', isMet: (p) => /[^A-Za-z0-9]/.test(p) || p.length >= 12 }
]

export const meetsPasswordRules = (password: string): boolean => PASSWORD_RULES.every(rule => rule.isMet(password))
